import { Box } from "@mui/material";
import { UiContainer } from "@ory/kratos-client";
import { FieldValues } from "react-hook-form";
import { UiForm, UiFormProps } from "../../../components";

export interface OidcFormProps<T extends FieldValues> {
  handleSubmit: UiFormProps<T>["handleSubmit"];
  ui: UiContainer;
  showProviders?: string[];
}

export const OidcForm = <T extends FieldValues>({
  handleSubmit,
  ui,
  showProviders,
}: OidcFormProps<T>) => (
  <Box>
    <UiForm
      handleSubmit={handleSubmit}
      ui={ui}
      groups={["oidc"]}
      withoutDefault
      showProviders={showProviders}
      sx={{ gap: "16px" }}
    />
  </Box>
);
